import styled from 'styled-components';
import { motion, useAnimation } from 'framer-motion';
import { transitionTween, stylesNoSelect } from 'Constants';

const SwitcherIcon = styled(motion.div)`
	margin: 0 4px 0 0;
	opacity: 0.66;
`;

export default SwitcherIcon;